import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { seo } from "../seo/schema";
import { SocialLinks } from "./SocialLinks";

const LINKS = [["/escape", "The Escape"], ["/europe", "Europe"], ["/getaway", "The Getaway"], ["/blog", "Blog"], ["/press", "Press"]];

export const HubHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-30 bg-black/90 backdrop-blur border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 h-20 flex items-center justify-between gap-4">
        <Link to="/" data-testid="hub-logo-link" className="shrink-0 font-display uppercase text-white text-xl sm:text-2xl leading-none tracking-wide">
          House Heads <span className="text-[#E50914]">At Sea</span>
        </Link>
        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map(([to, label]) => (
            <Link key={to} to={to} data-testid={`hub-nav-${to.slice(1)}`} className="font-cond uppercase tracking-widest text-sm text-white/75 hover:text-white transition-colors">
              {label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href="tel:+14706328963" data-testid="hub-call-btn" className="hidden sm:inline-flex items-center gap-2 bg-[#E50914] hover:bg-[#c20710] text-white font-cond uppercase tracking-widest text-xs rounded-full px-5 py-2.5 transition-colors">
            <Phone size={14} /> 470-632-8963
          </a>
          <button onClick={() => setOpen(!open)} data-testid="hub-menu-toggle" className="md:hidden text-white p-2" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="hub-mobile-menu" className="md:hidden border-t border-white/10 bg-black px-5 py-4 flex flex-col gap-4">
          {LINKS.map(([to, label]) => (
            <Link key={to} to={to} onClick={() => setOpen(false)} data-testid={`hub-mobile-nav-${to.slice(1)}`} className="font-cond uppercase tracking-widest text-white/80">
              {label}
            </Link>
          ))}
          <a href="tel:+14706328963" className="font-cond uppercase tracking-widest text-[#E50914]">Call 470-632-8963</a>
        </nav>
      )}
    </header>
  );
};

export const HubFooter = () => (
  <footer className="bg-[#0A0A0A] border-t border-white/10 py-10">
    <div className="max-w-7xl mx-auto px-5 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
      <div className="flex flex-col gap-4">
        <SocialLinks testPrefix="hub-social" />
        <p className="text-white/40 text-xs">© {new Date().getFullYear()} House Heads At Sea. Powered by DJ DaVyne &amp; Kompass Events.</p>
      </div>
      <nav className="flex flex-wrap gap-x-6 gap-y-2">
        {seo.nav.map((n) => (
          <Link key={n.href} to={n.href} data-testid={`hub-footer-link-${n.href.slice(1) || "home"}`} className="font-cond uppercase tracking-widest text-xs text-white/50 hover:text-white transition-colors">
            {n.label}
          </Link>
        ))}
      </nav>
    </div>
  </footer>
);
